import { combineActions, handleActions } from 'redux-actions'

import { enterRoom, onConnectionEstablished, onConnectionFailed } from '../actions/connection'
import { setJitsiRoom } from '../actions/conference'

export default handleActions<boolean, any>(
  {
    [enterRoom.toString()](state, { payload }) {
      return true
    },
    [combineActions(setJitsiRoom, onConnectionEstablished, onConnectionFailed).toString()](state, { payload }) {
      return false
    },
  },
  false
)
